// custom js here!
jQuery( document ).ready( function( $ ) {
  if( $('.slick > div').length ){
    $('.slick > div').slick({
      dots: false,
      infinite: true,
    });
  }
});